function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { CustomerAccountStatusSelector, IsFetchingAccountStatusDataSelector } from '../../../reducers/selectors/customer.account.status.selectors';
import { retrieveCustomerAccountStatus } from '../../../reducers/actions/customer.account.status.actions';
export var DiscountsModalController = /*#__PURE__*/function () {
  function DiscountsModalController($ngRedux) {
    _classCallCheck(this, DiscountsModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux
    });
    this.CustomerCareLocaleKeys = LocaleKeys;
  }
  return _createClass(DiscountsModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          accountStatus: CustomerAccountStatusSelector(store),
          isFetchingData: IsFetchingAccountStatusDataSelector(store)
        };
      };
      var controllerActions = {
        retrieveCustomerAccountStatus: retrieveCustomerAccountStatus
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.columnDefs = [{
        field: 'Discount.Name',
        displayName: i18n.translate(LocaleKeys.NAME),
        width: 225
      }, {
        field: 'Created',
        displayName: i18n.translate(LocaleKeys.ACTIVE_DISCRETIONARY_DISCOUNTS.ACTIVE_DATE),
        cellTemplate: require('./discounts.modal.cell.active.html'),
        width: 100
      }, {
        field: 'ExpirationDate',
        displayName: i18n.translate(LocaleKeys.ACTIVE_DISCRETIONARY_DISCOUNTS.EXPIRATION_DATE),
        cellTemplate: require('./discounts.modal.cell.expiration.html'),
        width: 85
      }, {
        field: 'ProductName',
        displayName: i18n.translate(LocaleKeys.PRODUCT),
        width: 198
      }];
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnect();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(_ref) {
      var openToggle = _ref.openToggle;
      if (openToggle.currentValue && this.state && !this.state.accountStatus) {
        this.actions.retrieveCustomerAccountStatus(this.state.currentCustomerId);
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.onClose();
    }
  }]);
}();
export default {
  template: require('./discounts.modal.html'),
  controller: DiscountsModalController,
  bindings: {
    onClose: '&',
    openToggle: '<'
  }
};